// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1_rMy","title":"InfoRow_title__2wv_j"};